export default __webpack_public_path__ + "static/media/save.727463f0.png";